import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import MsiteUserProfileOTPVerification from './personal-infor-user-otp';
import UserProfileOTPVerification from '../../../../myaccount/components/desktop/personal-info-user-otp';
import { getVerifyEmailOtp, verifyEmailOtp, getUserOtp, verifyUserProfileOTP } from '../../../../myaccount/actions/personalInfo';
import {
  getShowOtpMessageForMobile,
  getShowOtpMessageForEmail
} from '../../../../Flags/selectors.js';
import { gtmEventPush, segmentEventPush } from '../../../../modules/ga/GTMdatalayer';

type Fn = () => void;
interface EmailOtpVerifyProps {
  deviceType?: string;
  verifyEmailOTP: (otp: any, emailId: string, pageType: string) => void;
  fetchVerifyEmailOtp: Fn;
  personalInfo?: any;
  fromModal?: string;
  hideDialog?: Fn;
  verifyCoupon?: Fn;
  couponcode?: string;
  fetchVerifyMobileOtp : Fn;
  verifyMobileOTP: (otp: any, mobileNumber: string)=> Promise<void>;
  isAccountDelete: Boolean;
  openReadPolicyPage: Fn;
}

const EmailOtpVerify = (props: EmailOtpVerifyProps) => {
  const {
    deviceType,
    verifyEmailOTP,
    fetchVerifyEmailOtp,
    personalInfo = {},
    fromModal = '',
    hideDialog,
    verifyCoupon,
    couponcode = '',
    fetchVerifyMobileOtp,
    verifyMobileOTP,
    isAccountDelete = false,
    openReadPolicyPage
  } = props;
  const { emailOtpVerifyResponseObj: { message = '', statusCode = '' } = {} } = personalInfo;
  const [otp, setOTP] = useState('');
  const [secondsRemaining, setSecondsRemaining] = useState(60);
  const [userResend, setUserResend] = useState(false);
  const [intervalID, setIntervalID] = useState();
  const [isClickOnSubmit, setIsClickOnSubmit] = useState(false);
  const [otpErrorMsg, setOTPErrorMsg] = useState(false);
  const {
    personalInfo: { profile: { mobileNumber = '', uid = '' } = {} } = {},
  } = props;

  let clearIntervalID: any;
  const label = {
    editProfileText: 'Edit Profile',
    otpTitle: 'Verify Email ID',
    otpDescription: 'To verify your official email ID, please enter the OTP sent to',
    otpSubmitBtn: 'Verify'
  };
  const accountDeleteLabel = {
    editProfileText: 'Edit Profile',
    otpTitle: 'Enter OTP To Access Profile',
    otpDescription: 'To access profile enter OTP sent to',
    otpSubmitBtn: 'Verify'
  }
  if (fromModal == 'cart') {
    label.otpDescription =
      'To apply employee discount, verify your official email ID by entering an OTP sent to';
    label.otpSubmitBtn = 'Verify and Apply';
  }
  useEffect(() => {
    const { emailOtpVerifyResponseObj = {}, otpResponseObj = {}, otpVerifyResponseObj= {} } = props.personalInfo;
    if (emailOtpVerifyResponseObj?.statusCode !== '0') {
      setOTPErrorMsg(emailOtpVerifyResponseObj.message);
    }
    if (!otpResponseObj?.success && otpResponseObj?.message) {
      setOTPErrorMsg(otpResponseObj?.message);
    }
    if (otpVerifyResponseObj?.statusCode && otpVerifyResponseObj?.statusCode === '1' && otpVerifyResponseObj?.message) {
      if(isAccountDelete) {
        gtmEventPush({
          page_name: 'delete account opt half card',
          page_type: 'delete account opt half card',
          event: 'error_interactions',
          event_category: 'error interactions',
          event_action: 'delete profile',
          event_label: otpVerifyResponseObj.message || 'wrong OTP entered'
        });
        segmentEventPush({
          screen_name: 'Privacy Screen your data tab',
          page_name: 'Privacy Screen your data tab',
          // page_type: 'Privacy Screen your data tab',
          event: 'Delete Account OTP validation Status',
          event_category: 'error interactions',
          event_action: 'delete profile',
          status: 'failure',
          failure_reason: otpVerifyResponseObj.message || 'wrong OTP entered'
        });
      }
      setOTPErrorMsg(otpVerifyResponseObj?.message);
    }
  }, [props?.personalInfo]);

  useEffect(() => {
    if(!isAccountDelete) {
      fetchVerifyEmailOtp();
      callBackResendTimer();
      gtmEventPush({
        event: 'openScreen',
        screen_name: 'Employee verify email screen'
      });
    } else {
      gtmEventPush({
        event: 'pageload',
        screen_name: 'delete account opt half card',
        page_name: 'delete account opt half card',
        page_type: 'delete account opt half card',
      });
      segmentEventPush({
        event: 'Delete account half card viewed',
        screen_name: 'Privacy Screen your data tab',
        page_name: 'Privacy Screen your data tab',
        page_type: 'Privacy Screen your data tab'
      });
      const userDetailObj = {
        mobileNumber,
        emailId: uid
      };
      fetchVerifyMobileOtp(userDetailObj);
      callBackResendTimer();
    }
  }, []);

  useEffect(() => {
    if (statusCode && isClickOnSubmit) {
      if (statusCode == '0') {
        if (typeof hideDialog == 'function') {
          hideDialog();
        }
        if (fromModal == 'cart' && typeof verifyCoupon == 'function') {
          window.location.reload();
          verifyCoupon();
        }
      }
    }
  }, [statusCode]);

  useEffect(() => {
    if (secondsRemaining == 0) {
      if(isAccountDelete) {
        gtmEventPush({
          page_name: 'delete account opt half card',
          page_type: 'delete account opt half card',
          event: 'error_interactions',
          event_category: 'error interactions',
          event_action: 'delete profile',
          event_label: 'OTP timeout'
        });
        segmentEventPush({
          screen_name: 'Privacy Screen your data tab',
          page_name: 'Privacy Screen your data tab',
          // page_type: 'Privacy Screen your data tab',
          event: 'Delete Account OTP validation Status',
          event_category: 'error interactions',
          event_action: 'delete profile',
          status: 'failure',
          failure_reason: 'OTP timeout'
        });
      }
      clearInterval(intervalID);
    }
  }, [secondsRemaining]);

  const enterPressed = (event: any, otp: any, mobileNumber: any, emailId: string) => {
    if (event.keyCode === 13 || event.charCode === 13) {
      event.preventDefault();
      if(!isAccountDelete) {
        verifyEmailOTP(otp, emailId, fromModal == 'cart' ? 'cart' : 'account');
      } else {
        gtmEventPush({
          page_name: 'delete account opt half card',
          page_type: 'delete account opt half card',
          event: 'your_data_interactions',
          event_category: 'your data interactions',
          event_action: 'confirm OTP'
        });
        verifyMobileOTP(otp, mobileNumber).then((response: any) => {
          console.log('verify response', response);
          const { statusCode = '', message = '' } = response;
          if (statusCode === '0' && message == 'success') {
            segmentEventPush({
              screen_name: 'Privacy Screen your data tab',
              page_name: 'Privacy Screen your data tab',
              // page_type: 'Privacy Screen your data tab',
              event: 'Delete Account OTP validation Status',
              event_category: 'your data interactions',
              event_action: 'confirm OTP',
              status: 'success'
            });
            openReadPolicyPage();
          }
        }).catch((err: any) => {
          console.log('verify error', err);
        });
      }
    }
  };
  const submitUserOTP = (event: any, otp: any, mobileNumber: any, emailId: string) => {
    event.preventDefault();
    if(!isAccountDelete) {
    gtmEventPush({
      event: 'buttonTap',
      event_category: 'buttonTap',
      event_action: fromModal == 'cart' ? 'verify and apply click' : 'verify email click',
      event_label: fromModal == 'cart' ? couponcode : 'verification bottom screen',
      screen_name: 'Employee verify email screen'
    });
   
    setIsClickOnSubmit(true);
    verifyEmailOTP(otp, emailId, fromModal == 'cart' ? 'cart' : 'account');
    } else {
      gtmEventPush({
        page_name: 'delete account opt half card',
        page_type: 'delete account opt half card',
        event: 'your_data_interactions',
        event_category: 'your data interactions',
        event_action: 'confirm OTP'
      });
      setIsClickOnSubmit(true);
      verifyMobileOTP(otp, mobileNumber).then((response: any) => {
        console.log('verify response', response);
        const { statusCode = '', message = '' } = response;
        if (statusCode === '0' && message == 'success') {
          segmentEventPush({
            screen_name: 'Privacy Screen your data tab',
            page_name: 'Privacy Screen your data tab',
            // page_type: 'Privacy Screen your data tab',
            event: 'Delete Account OTP validation Status',
            event_category: 'your data interactions',
            event_action: 'confirm OTP',
            status: 'success'
          });
          openReadPolicyPage();
        }
      }).catch((err: any) => {
        console.log('verify error', err);
      });
    }
  };

  const handleOTPChange = (event: any) => {
    setOTP(event.target.value);
  };

  const resendOTP = (mobileNumber: any, emailId: any) => {
    if (secondsRemaining == 0) {
      if(!isAccountDelete) {
        fetchVerifyEmailOtp();
      } else {
        gtmEventPush({
          page_name: 'delete account opt half card',
          page_type: 'delete account opt half card',
          event: 'your_data_interactions',
          event_category: 'your data interactions',
          event_action: 'resend OTP'
        });
        const userDetailObj = {
          mobileNumber,
          emailId: uid
        };
        fetchVerifyMobileOtp(userDetailObj);
      }
      setSecondsRemaining(60);
      setUserResend(true);
      callBackResendTimer();
    }
  };

  const callBackResendTimer = () => {
    const SEC = 1000;
    clearIntervalID = setInterval(() => setSecondsRemaining(prevTime => prevTime - 1), SEC);
    setIntervalID(clearIntervalID);
  };

  const modalParams = {
    otp,
    otpTitle: isAccountDelete? accountDeleteLabel.otpTitle : label.otpTitle,
    otpDescription: isAccountDelete? accountDeleteLabel.otpDescription: label.otpDescription,
    otpSubmitBtn: isAccountDelete? accountDeleteLabel.otpSubmitBtn : label.otpSubmitBtn,
    handleOTPChange,
    submitUserOTP,
    resendOTP,
    personalInfo,
    message: otpErrorMsg,
    statusCode,
    secondsRemaining,
    enterPressed,
    app: deviceType,
    isAccountDelete: isAccountDelete 
  };
  return deviceType !== 'MSITE' ? (
    <UserProfileOTPVerification
      {...props}
      {...modalParams}
      otp_popup_display_mobile={false}
      otp_popup_display_email
    />
  ) : (
    <MsiteUserProfileOTPVerification {...modalParams} />
  );
};

const mapStatetoProps = (state: any) => {
  const { personalInfo = [], httpError = {}, flags = {} } = state;

  return {
    personalInfo,
    httpError,
    otp_popup_display_mobile: getShowOtpMessageForMobile(flags),
    otp_popup_display_email: getShowOtpMessageForEmail(flags)
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    fetchVerifyEmailOtp: () => dispatch(getVerifyEmailOtp()),
    verifyEmailOTP: (otp: any, emailId: string, pageType: string) =>
      dispatch(verifyEmailOtp(otp, emailId, pageType)),
    fetchVerifyMobileOtp: (userDetailObj: any) => dispatch(getUserOtp(userDetailObj)),
    verifyMobileOTP: (otp: any, mobileNumber: string) =>
      dispatch(verifyUserProfileOTP(otp, mobileNumber))
  };
};
export default connect(mapStatetoProps, mapDispatchToProps)(EmailOtpVerify);
